import React, { useEffect } from 'react';
import { Box, Grid, Button, Typography } from '@mui/material';
import CustomTable from '../../components/table/TeacherTable';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import Addstudent from './Addteacher';
import { useDispatch, useSelector } from 'react-redux';
import { getteacher } from '../../slices/teacher';
import Addexcel from './Addexcel';
import SearchButton from '../../components/search/Search';

const columns = [
  { id: 'sno', label: 'S.No', minWidth: 150, align:'start' },
  { id: 'name', label: 'Name', minWidth: 150, align:'start' },
  { id: 'className', label: 'Class', minWidth: 150, align:'start' },
  { id: 'phone', label: 'Phone Number', minWidth: 150, align:'center' },
  { id: 'address', label: 'Address', minWidth: 150, align:'center' },
  { id: 'action', label: 'Action', minWidth: 100, align:'center', actionType: [{edit: true, delete: true}] },
];

const rows = [
  {sno: '01', name: 'Cow', class:'Girr', section: 'url', phone_number: '+91 6545644456', address:'Coimbatore'},
  {sno: '02', name: 'Cow', class:'Girr', section: 'url', phone_number: '+91 6545644456', address:'Coimbatore'},
];

const Teacher = ({setLoader}) => {

  const [filteredData, setFilteredData] = React.useState();

  const {teachers: teacherData} = useSelector((state) => state.teacher);

  const dispatch = useDispatch();

  const rows = teacherData?.map((va, index)=>{
    return{...va, sno: index+1}
  })

  const handleSearch = (query) => {
    const filtered = rows.filter(item => item.name.toLowerCase().includes(query));
    setFilteredData(filtered);
  };

  React.useEffect(()=>{
    setFilteredData(rows);
  }, [teacherData])

  useEffect(()=>{
    setLoader(true)
      dispatch(getteacher())
      .then(() => {
        setLoader(false);
      })
      .catch(()=>{
        setLoader(false);
      })
  }, [])

  return (
    <div className="content">
        <Box>
        <Grid container spacing={3} sx={{ paddingBottom: 2, alignItems:'center' }}>
          <Grid item xs={12} sx={{paddingTop: 0}}>
          <Typography className="headline" variant="h5" sx={{ fontWeight:'bold'}}>Teacher Information</Typography>
          </Grid>
          <Grid item xs={3} sx={{paddingTop: 0}}>
          <SearchButton handleSearch={handleSearch} placeholder="Search Student"/>
          </Grid>
          <Grid item xs={3} sx={{ paddingTop: 0}}>
            <Addstudent  setLoader={setLoader}/>
          </Grid>
          <Grid item xs={3} sx={{paddingTop: 0}}>
            <Addexcel setLoader={setLoader}/>
          </Grid>
          <Grid item xs={3} sx={{textAlign: 'end', paddingTop: 0}}>
          <Button fullWidth variant='contained'>Export</Button>
          </Grid>
          </Grid>
        </Box>
         <Box>
           <CustomTable setLoader={setLoader} columns={columns} rows={filteredData ? filteredData : []} />
         </Box>
    </div>
  );
}

export default Teacher;